import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';


export interface ProgramItemBannerProps {
  imgSrc: string;
  reverseOrder: boolean;
  title: string;
  description: string;
  backgroundColor: string;
}

const Background = styled.div<{ backgroundColor: string }>`
  background-color: ${props => props.backgroundColor};
`;

const Inner = styled.div<{ reverseOrder: boolean }>`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    flex-direction: ${(props) => props.reverseOrder ? 'row-reverse' : 'row'}
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    flex-direction: ${(props) => props.reverseOrder ? 'row-reverse' : 'row'}
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
    padding-top: 100px;
  }

  @media ${DEVICES.large} {
    width: 50%;
    padding-top: 200px;
  }
`;

const RightTag = styled.div`
  font-weight: 500;
  color: #777;
  @media ${DEVICES.mobile} {
    font-size: 1.1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8em;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightTitle = styled.div`
  font-weight: 700;
  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.8rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2rem;
`;

export default function ProgramItemBanner(props: ProgramItemBannerProps) {
  return (
    <Background backgroundColor={props.backgroundColor}>
      <Inner reverseOrder={props.reverseOrder}>
        <Left>
          <LeftImg src={props.imgSrc} />
        </Left>
        <Right>
          <RightTag>
            캥거루짐
          </RightTag>
          <RightTitle>
            {props.title}
          </RightTitle>
          <RightDescription>
            {props.description}
          </RightDescription>
        </Right>
      </Inner>
    </Background>
  )
}